import styled from 'styled-components';
import { borderRadius, colorUsage, getSpacing } from 'stylesheet';
var SlideContainer = styled.div.withConfig({
  displayName: "SlidePositionstyle__SlideContainer",
  componentId: "sc-15bw5jc-0"
})(["position:relative;margin-top:", ";padding:", ";border:1px solid ", ";border-radius:", ";"], getSpacing(3), getSpacing(3), colorUsage.filtersBarBorder, borderRadius.large);
var Container = styled.div.withConfig({
  displayName: "SlidePositionstyle__Container",
  componentId: "sc-15bw5jc-1"
})(["display:flex;align-items:center;"]);
var SelectSlideContainer = styled.div.withConfig({
  displayName: "SlidePositionstyle__SelectSlideContainer",
  componentId: "sc-15bw5jc-2"
})(["margin-left:", ";"], getSpacing(3));
export { SlideContainer, Container, SelectSlideContainer };